const init = function() {

    // Setup ToC anchor jumps without adding to history
    const tocMenus = document.querySelectorAll('.sidebar-toc')

    if ( tocMenus ) {
        tocMenus.forEach( menu => {

            const menuLinks = menu.querySelectorAll('a')

            if ( menuLinks ) {
                menuLinks.forEach( link => {

                    link.addEventListener( 'click', ( event ) => {
                        event.preventDefault()
                        const anchorId = link.getAttribute('href').replaceAll( '#', '' )
                        const scrollTarget = document.getElementById( anchorId )
                        if ( scrollTarget ) scrollTarget.scrollIntoView()
                    } )

                } )
            }

        } )
    }

}

const api = {
	init: init
};

export default api;